import React from 'react'
import Navbar from './Navbar'
import Career1 from './career_c1'
import Career2 from './career_c2'
import Career3 from './career_c3'

import Footer from './Footer'
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll'

function Full_career() {
      const [showScrollTop, setShowScrollTop] = useState(false);
       const [showForm, setShowForm] = useState(false);
      
    
      useEffect(() => {
        const handleScroll = () => {
          setShowScrollTop(window.scrollY > 200);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
    
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
  return (
    <div>
      <Navbar onEnrollClick={() => setShowForm(true)} /><br></br><br></br><br></br><br></br>
        <Career1/><br></br>
        <Career2/>
        <Career3/>
        
        <Footer/>
          <a
        href="https://wa.me/9944897638"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Scroll to Top Icon */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </div>

    

  )
}

export default Full_career